import React, { useState, useEffect } from 'react';
import './../entrydoor.css';
import { alertC } from './../components/dialogService';

const CascadingCombo = ({
  value = [],
  onChange,
  label = 'Cascading Combo:',
  disabled = false,
  options = ['A', 'B', 'C'],
}) => {
  const [combos, setCombos] = useState(
    value.length ? value : [{ id: 'CascadingCombo1', value: '' }]
  );

  const generateId = () => {
    const existingNumbers = combos
      .map(c => parseInt(c.id.replace('CascadingCombo', ''), 10))
      .filter(n => !isNaN(n));
  
    const maxIndex = Math.max(0, ...existingNumbers);
    return `CascadingCombo${maxIndex + 1}`;
  };

  useEffect(() => {
    if (value.length > 0 && JSON.stringify(value) !== JSON.stringify(combos)) {
      setCombos(value);
    }
  }, [value]);

  const handleChange = (id, selectedValue) => {
    const isAlreadySelected = combos.some(
      combo => combo.value === selectedValue && combo.id !== id
    );

    if (isAlreadySelected) {
      alertC(`${selectedValue} already selected`);
      return;
    }

    const selectedCombo = combos.find(combo => combo.id === id);

    if (!selectedCombo) return;

    const updatedCombos = [...combos];

    // Add new disabled combo with selected value
    updatedCombos.push({
      id: generateId(),
      value: selectedValue,
      locked: true,
    });

    onChange?.(updatedCombos);
    setCombos(updatedCombos);
  };

  const handleDelete = (id) => {
    const updated = combos.filter(c => c.id !== id);
    onChange?.(updated);
    setCombos(updated);
  };

  return (
    <div className="a-container">
      <label disabled={disabled}>{label}</label>
      {combos.map((combo, index) => (
        <div
          key={combo.id}
          style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}
        >
 <select
  id={combo.id}
  value={combo.value}
  onChange={e => handleChange(combo.id, e.target.value)}
  disabled={index !== 0 || disabled}
  className="p-2 border rounded-md w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
>

            <option value="">Select an option</option>
            {options.map(opt => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>

          {index > 0 && (
  <button
    onClick={() => handleDelete(combo.id)}
    type="button"
    style={{
      marginLeft: '10px',
      background: '#e74c3c',
      color: '#fff',
      border: 'none',
      padding: '6px 10px',
      borderRadius: '4px',
      cursor: 'pointer',
    }}
  >
    Delete
  </button>
)}
       </div>
      ))}
    </div>
  );
};

export default CascadingCombo;
